import type { RequestConfig } from './model';
import { vanillaRequest } from './vanillaRequest';
import { getSession } from './getSession';

const requestCreator = (domain: string) => {
  // `axios like` api pattern
  return {
    async get<O = any>(url: string, options?: RequestConfig): Promise<O> {
      return vanillaRequest(`${domain}${url}`, {
        ...options,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'app-version': '1',
          appkey: 'mobile@webapp',
          'session-token': await getSession(),
          ...options?.headers,
        },
      });
    },
    async post<I extends Record<string, any>, O = any>(
      url: string,
      body: I,
      options?: RequestConfig
    ): Promise<O> {
      return vanillaRequest(`${domain}${url}`, {
        ...options,
        method: 'POST',
        body,
        headers: {
          'Content-Type': 'application/json',
          'app-version': '1',
          appkey: 'mobile@webapp',
          'session-token': await getSession(),
          ...options?.headers,
        },
      });
    },
    async put<I extends Record<string, any>, O = any>(
      url: string,
      body: I,
      options?: RequestConfig
    ): Promise<O> {
      return vanillaRequest(`${domain}${url}`, {
        ...options,
        method: 'PUT',
        body,
        headers: {
          'Content-Type': 'application/json',
          'app-version': '1',
          appkey: 'mobile@webapp',
          'session-token': await getSession(),
          ...options?.headers,
        },
      });
    },
    async delete<I extends Record<string, any>, O = any>(
      url: string,
      body: I,
      options?: RequestConfig
    ): Promise<O> {
      return vanillaRequest(`${domain}${url}`, {
        ...options,
        method: 'DELETE',
        body,
        headers: {
          'Content-Type': 'application/json',
          'app-version': '1',
          appkey: 'mobile@webapp',
          'session-token': await getSession(),
          ...options?.headers,
        },
      });
    },
  };
};

// export const openApiRequest = requestCreator(process.env.RAZZLE_OPEN_API!);
export const mobileApiRequest = requestCreator(process.env.RAZZLE_API_MOBILE!);
